import { apiConfig, EnumAPIKey } from "@/constants/app/api"
import { EnumEndpoints } from "@/constants/app/type"
import { FlatFareConfigMap } from "./flatFareProduct.types"
import { parseFlatFareProducts } from "./parseFlatFareProducts"

export const FLIGHT_PRODUCT_CODES = ["QH", "VJ"] as const

const getAccessToken = () =>
  typeof localStorage !== "undefined" ? localStorage.getItem("apiAccessToken") : null

let cachedConfig: FlatFareConfigMap | null = null
let inflightRequest: Promise<FlatFareConfigMap> | null = null

async function fetchFlightProductsOnce(): Promise<FlatFareConfigMap> {
  const endpoint = `${apiConfig[EnumAPIKey.API_BASE]}${EnumEndpoints.PRODUCTS_GET}`
  const token = getAccessToken()

  try {
    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify([...FLIGHT_PRODUCT_CODES]),
    })

    if (!res.ok) {
      return {}
    }

    const json = await res.json().catch(() => [])
    const products = Array.isArray(json) ? json : []
    return parseFlatFareProducts(products)
  } catch {
    return {}
  }
}

export async function fetchFlightProducts(): Promise<FlatFareConfigMap> {
  if (cachedConfig) {
    return cachedConfig
  }

  if (inflightRequest) {
    return inflightRequest
  }

  inflightRequest = fetchFlightProductsOnce()
    .then((config) => {
      cachedConfig = config
      inflightRequest = null
      return config
    })
    .catch((error) => {
      inflightRequest = null
      throw error
    })

  return inflightRequest
}

export const getFlatFareConfigCache = () => cachedConfig || {}

export const seedFlatFareConfigCache = (config: FlatFareConfigMap) => {
  cachedConfig = config
}

export const clearFlatFareConfigCache = () => {
  cachedConfig = null
  inflightRequest = null
}
